// ── Push notifications — Web Notifications API + Supabase ────────────────
// FCM has been replaced by native Web Notifications + Supabase Realtime.
// For full FCM support, add @firebase/messaging separately if needed.

// ── Detect iOS Safari (Web Push not supported before iOS 16.4 PWA) ─────────
export function isIosSafariWithoutPush() {
  const ua = navigator.userAgent;
  const isIos = /iphone|ipad|ipod/i.test(ua);
  if (!isIos) return false;
  // iOS 16.4+ supports Web Push only when installed as a PWA (standalone)
  const isStandalone = window.navigator.standalone === true;
  const safariVersion = ua.match(/version\/(\d+)/i)?.[1];
  const version = safariVersion ? parseInt(safariVersion) : 0;
  return !isStandalone || version < 16;
}

// ── Request browser notification permission ───────────────────────────────
export async function requestPushPermission() {
  if (isIosSafariWithoutPush()) {
    return { token: null, error: 'ios_unsupported' };
  }
  if (!('Notification' in window)) return { token: null, error: 'Not supported' };
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return { token: null, error: 'Permission denied' };
    return { token: 'web-push-granted', error: null };
  } catch (err) {
    return { token: null, error: err.message };
  }
}

// ── In-app toast via custom event ─────────────────────────────────────────
export function showToast({ title, body, onClick }) {
  window.dispatchEvent(new CustomEvent('beelove-toast', {
    detail: { title, body, onClick }
  }));
}

// ── No-op for foreground messages (handled by Supabase Realtime) ──────────
export function onForegroundMessage(callback) {
  return () => {};
}

export const NOTIF_TYPES = {
  NEW_MATCH:       'new_match',
  NEW_MESSAGE:     'new_message',
  CIRCLE_PROPOSAL: 'circle_proposal',
  EVENT_REMINDER:  'event_reminder',
  FRIEND_VOTED:    'friend_voted',
  PROFILE_BOOST:   'profile_boost',
  WEEKLY_DIGEST:   'weekly_digest',
};
